import versoCall from "@/assets/images/canais/versocall.png";
import versoCommerce from "@/assets/images/canais/versocommerce.png";
import versoApp from "@/assets/images/canais/versoapp.png";
import versoVendas from "@/assets/images/canais/versovendas.png";

export const CANAIS_CASHBACK = {
  CALLCENTER: { imagem: versoCall, descricao: "Pedidos digitados pelo operador" },
  VCOM: { imagem: versoCommerce, descricao: "Loja virtual" },
  B2B_APP: { imagem: versoApp, descricao: "Aplicativo do cliente" },
  FORCA_VENDAS: { imagem: versoVendas, descricao: "Pedidos do representante, inclusive offline" },
};

export const imagemCanal = (chave) => CANAIS_CASHBACK[chave]?.imagem || "";

export const descricaoCanal = (chave) => CANAIS_CASHBACK[chave]?.descricao || "";
